import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import SectionHeading from "@/components/base/SectionHeading";
import { galleryItems } from "@/data/gallery";

export default function GalleryPreview() {
  const [feature, ...supporting] = galleryItems;
  const tiles = supporting.slice(0, 4);

  return (
    <section id="gallery" className="relative scroll-mt-28 overflow-hidden bg-gradient-to-b from-background-50 to-secondary-50/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Inside Our Clinic"
            title="A closer look at the care we provide"
            align="left"
            description="Real moments from consultations and examinations at Ortho Spine Care — because good care starts with listening."
          />
          <Button to="/gallery" variant="outline" size="md" icon="ri-image-2-line">
            View Gallery
          </Button>
        </div>

        <div className="reveal mt-10 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:grid-rows-2 lg:h-[520px]">
          <Link
            to="/gallery"
            className="group relative col-span-2 h-[240px] cursor-pointer overflow-hidden rounded-2xl border border-background-200 ring-2 ring-primary-200/60 sm:h-[300px] lg:row-span-2 lg:h-full"
          >
            <img
              src={feature.image}
              alt={feature.alt}
              title={`${feature.title} — Ortho Spine Care gallery`}
              className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div
              className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-accent-950/15 to-transparent"
              aria-hidden="true"
            ></div>
            <div className="absolute bottom-5 left-5 right-5">
              <span className="inline-flex rounded-full bg-background-50/90 px-3 py-1 font-label text-xs font-semibold text-primary-800">
                {feature.category}
              </span>
              <p className="mt-3 font-heading text-lg font-semibold text-background-50">{feature.title}</p>
            </div>
          </Link>

          {tiles.map((item) => (
            <Link
              key={item.title}
              to="/gallery"
              className="group relative h-[140px] cursor-pointer overflow-hidden rounded-2xl border border-background-200 sm:h-[180px] lg:h-full"
            >
              <img
                src={item.image}
                alt={item.alt}
                title={`${item.title} — Ortho Spine Care gallery`}
                className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-primary-950/0 transition-all duration-300 group-hover:bg-gradient-to-t group-hover:from-primary-950/80 group-hover:via-accent-950/30 group-hover:to-transparent"
                aria-hidden="true"
              ></div>
              <span className="absolute bottom-3 left-3 right-3 translate-y-2 font-label text-xs font-semibold text-background-50 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                {item.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}